import React, { FC } from 'react';
import { Button } from 'antd';
import { DrawerProps } from 'antd/lib/drawer';
import { useTranslation } from 'react-i18next';

import Form from '~/components/Form';
import { SaveIcon } from '~/img';
import Drawer from './Drawer';

interface FormDrawerProps extends DrawerProps {
  name: string;
  onFinish: (values: any) => void;
  loading?: boolean;
}

const FormDrawer: FC<FormDrawerProps> = (props) => {
  const { children, name, onFinish, loading, ...rest } = props;
  const [t] = useTranslation();

  return (
    <Drawer
      footer={
        <div
          style={{
            textAlign: 'right',
          }}
        >
          <Button
            loading={loading}
            type="primary"
            form={name}
            htmlType="submit"
            icon={<SaveIcon />}
          >
            {t('save')}
          </Button>
        </div>
      }
      {...rest}
    >
      <Form.Provider
        onFormFinish={(n, info) => {
          const { values } = info;
          onFinish(values);
        }}
      >
        {children}
      </Form.Provider>
    </Drawer>
  );
};

export default FormDrawer;
